import { render, staticRenderFns } from "./p09.vue?vue&type=template&id=1c11641b&scoped=true&"
import script from "./p09.vue?vue&type=script&lang=js&"
export * from "./p09.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c11641b",
  null
  
)

export default component.exports